import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from 'state';
// import { persistStore } from 'redux-persist';
// import { PersistGate } from 'redux-persist/integration/react';
import MainRouter from 'components/MainRouter';

import {
  GlobalStyle,
  BaseContainer,
} from './style';

// const persistor = persistStore(store);

const MainContainer = (): JSX.Element => (
  <Provider store={store}>
    {/* <PersistGate persistor={persistor}> */}
    <GlobalStyle />
    <BaseContainer>
      <BrowserRouter>
        <MainRouter />
      </BrowserRouter>
    </BaseContainer>
    {/* </PersistGate> */}
  </Provider>
);

export default MainContainer;
